import React, { useEffect, useState } from 'react';
import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery } from '@mui/material';

const PartyInwardView = () => {
    const [formData, setFormData] = useState([]);
    const isDesktop = useMediaQuery('(min-width:768px)');
    useEffect(() => {
        // Retrieve the URL parameters
        const query = new URLSearchParams(window.location.search);
        const formParam = query.get('form');

        if (formParam) {
            try {
                // Parse the form data
                const parsedForm = JSON.parse(decodeURIComponent(formParam));
                setFormData(parsedForm);
            } catch (error) {
                console.error('Error parsing form data:', error);
            }
        }
    }, []);
    // console.log(formData)

    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Paper style={{ padding: '2vh' }}>

                        <div style={{ margin: '1% 0%', width: '100%' }}>

                            <h3 className='centered-heading'>Party Inward View</h3>
                            <div className="dashed-line"></div>

                            {formData?.material?.length > 0 &&
                                <div>
                                    <h3>Material</h3>
                                    <table style={{ width: '100%' }}>
                                        <thead>
                                            <tr>
                                                <th>Sr. No.</th>
                                                <th>Material Work</th>
                                                <th>Qty</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {formData?.material?.map((mat, matIndex) => (
                                                <>
                                                    <tr key={matIndex}>
                                                        <td>
                                                            {matIndex + 1}
                                                        </td>
                                                        <td>
                                                            {mat.materialNm}
                                                        </td>
                                                        <td>
                                                            {mat.qty}
                                                        </td>


                                                    </tr>
                                                </>
                                            ))}
                                            <tr>
                                                <td> </td>
                                                <td>
                                                    <span className="tot-lump">Total Qty</span>
                                                </td>
                                                <td>
                                                    <span className="tot-lump">{formData.totmtqty}</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                </div>
                            }

                            {formData?.size?.length > 0 &&
                                <div>
                                    <h3>Item Sizes</h3>
                                    <table style={{ width: '100%' }}>
                                        <tbody>
                                            <tr>
                                                <td>Size</td>
                                                {formData?.size?.map((val, valIndex) => (
                                                    <td key={valIndex}>
                                                        {val}
                                                    </td>
                                                ))}
                                            </tr>
                                            <tr>
                                                <td>Qty</td>
                                                {formData?.qty?.map((val, valIndex) => (
                                                    <td key={valIndex}>
                                                        {val}
                                                    </td>
                                                ))}
                                            </tr>

                                        </tbody>
                                    </table>

                                </div>}
                        </div>
                    </Paper>
                </Grid>
            </Grid>
        </>
    );
};

export default PartyInwardView;
